// removed commented code
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Helmet } from "react-helmet";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Element } from "react-scroll";
import Cookies from "universal-cookie";
import * as Yup from "yup";
import { toast } from "react-toastify";
import menuBg from "../../assets/images/bg/menu/home.svg";
import upcomingBg from "../../assets/images/bg/upcoming.svg";
import angleLeft from "../../assets/images/icons/angle-left.svg";
import angleRight from "../../assets/images/icons/angle-right.svg";
import like from "../../assets/images/icons/like.svg";
import unlike from "../../assets/images/icons/unlike.svg";
import Footer from "../../components/footer";
import FooterBottom from "../../components/footerBottom";
import TextInput from "../../components/formfields/InputField";
import SubmitLoader from "../../components/SubmitLoader";
// components
import Header from "../../components/header";
import LoginModal from "../../components/loginModal";
import MainMenu from "../../components/mainMenu";
import SuccessModal from "../../components/successModal";
import UpcomingHero from "../../components/upcoming/hero";
import { getUpcomingDetailsAction } from "../App/actions";

import { addVoteAction, getPublicFeatureListAction } from "./actions";

import "./style.scss";
import logo from "../../assets/images/logo.png";
import { voteOnFeatureAction } from "../requestAFeature/actions";
import CustomButton from "../../components/Buttons/CustomButton";
import { Col, Row } from "react-bootstrap";

const cookie = new Cookies();

const validationSchema = Yup.object({
  title: Yup.string().required("title can not be empty"),
  description: Yup.string().required("description can not be empty"),
});
function UpcomingFeatured(props) {
  const { userInfo, upcoming, featureList, meta } = props;
  const [openMenu, setOpenMenu] = useState(false);
  const [isModalLogin, setIsModalLogin] = useState(false);
  const [success, setSuccess] = useState(false);
  const [selected, setSelected] = useState(0);
  const [keyword, setKeyword] = useState("");
  const userToken = cookie.get("user_token");

  const dispatch = useDispatch();
  const history = useHistory();

  const initialState = {
    title: "",
    description: "",
    featureIdea: true,
  };

  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      );
    },
  });

  const thumbs = files.map((file) => (
    <li key={file.name}>
      <img src={file.preview} alt={file.name} />
    </li>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };
  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const handleSubmit = (values, actions) => {
    const data = {
      idea: values.featureIdea,
      title: values.title,
      description: values.description,
      image: files,
    };

    if (userToken) {
      if (!userInfo?.email_verified_at) {
        history.push("/confirm-email");
        toast.error("Please verify email");
      } else if (userInfo?.is_complete === "0") {
        history.push("/account-complete");
      } else {
        dispatch(voteOnFeatureAction(data, actions, setFiles, setSuccess));
      }
    } else {
      setIsModalLogin(true);
    }
  };

  useEffect(() => {
    dispatch(getPublicFeatureListAction("paginate=25"));
    dispatch(getUpcomingDetailsAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAddVote = (post_id, type) => {
    const data = {
      post_id,
      vote: type,
    };
    if (userToken) {
      dispatch(addVoteAction(data));
    } else {
      setIsModalLogin(true);
    }
  };
  const handleChangePaginate = (value) => {
    setSelected(value.selected);
    dispatch(getPublicFeatureListAction(`page=${value.selected + 1}&paginate=25`));
  };

  useEffect(() => {
    if (props?.upcoming?.keyword?.length > 0) {
      const data = props?.upcoming?.keyword;
      const pp = data.toString();
      setKeyword(pp);
    }
  }, [props?.upcoming?.keyword]);

  return (
    <>
      <Helmet>
        <title>Upcoming Features for Therapists - Clarity Cooperative</title>
        <meta name="title" content={"Upcoming Features for Therapists - Clarity Cooperative"} />
        <meta name="description" content={props?.upcoming?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={"Upcoming Features for Therapists - Clarity Cooperative"} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={props?.upcoming?.url} />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.upcoming?.excerpt} />
        <meta name="twitter:card" content={props?.upcoming?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.upcoming?.url} />
        <meta name="twitter:title" content={"Upcoming Features for Therapists - Clarity Cooperative"} />
        <meta name="twitter:description" content={props?.upcoming?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleWhite" logoWhite />
      <UpcomingHero data={upcoming} />
      <Element name="test1">
        <section className="upcomingFeaturedArea">
          <ul className="upcomingFeaturedItems">
            {featureList?.data?.map((item) => (
              <li key={item.id} className="upcomingFeaturedWrap">
                <div className="upcomingFeaturedImg">
                  <img className="img-fluid" src={item.image} alt={item.name} />
                </div>
                <div className="upcomingFeaturedContent">
                  <div className="upcomingFeatured">
                    <span>{item.coming_in}</span>
                    <h2>{item.name}</h2>
                    <p>{item.description}</p>
                  </div>
                  <ul className="upcomingFeaturedLike">
                    <li>
                      <button type="submit" onClick={() => handleAddVote(item.id, 1)} className="like">
                        <img src={like} alt="like" />
                        {item.up_vote > 0 && <span className="value">{item.up_vote}</span>}
                      </button>
                    </li>
                    <li>
                      <button type="submit" onClick={() => handleAddVote(item.id, 2)} className="unlike">
                        <img src={unlike} alt="unlike" />
                        {item.down_vote > 0 && <span className="value">{item.down_vote}</span>}
                      </button>
                    </li>
                  </ul>
                </div>
              </li>
            ))}
          </ul>
          <div className="paginationFeatured">
            {featureList?.total > featureList?.per_page && (
              <ReactPaginate
                containerClassName="paginationWrapper"
                pageCount={featureList.total / featureList.per_page}
                pageRangeDisplayed={featureList.per_page}
                onPageChange={handleChangePaginate}
                nextLabel={<img src={angleRight} alt="right" />}
                previousLabel={<img src={angleLeft} alt="left" />}
                forcePage={selected}
              />
            )}
          </div>
        </section>
      </Element>
      {userToken ? (
        <section
          className="usefulFeatureArea2Style usefulFeatureArea"
          style={{
            background: `url(${upcomingBg}) no-repeat center center / cover`,
          }}
        >
          <div className="usefulFeatureTitle">
            <h2>{upcoming?.useful_title}</h2>
            <p>{upcoming?.useful_paragraph}</p>
          </div>

          <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, handleChange, handleBlur, setFieldValue }) => {
              return (
                <Form className="usefulFeatureForm">
                  <div className="usefulFeatureFormBG">
                    <Row className="gy-3">
                      <Col xs={12}>
                        <Field
                          label="Title Of Feature*"
                          id="title"
                          name="title"
                          component={TextInput}
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Enter Title"
                        />
                      </Col>
                      <Col xs={12}>
                        <Field
                          label="Description Of Feature*"
                          id="description"
                          name="description"
                          component={TextInput}
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Describe your idea in as much detail as you can"
                        />
                      </Col>

                      <Col xs={12}>
                        <label htmlFor="featureIdea">Do you have and example of a similar feature? Send us a screenshot!</label>
                        <div {...getRootProps({ className: "dropzoneStyle mt-0" })}>
                          <input {...getInputProps()} />
                          <p>Drag & Drop files here to upload.</p>
                          <button type="button">Browse</button>
                        </div>
                        <ul className="thumbImages">{thumbs}</ul>
                      </Col>

                      <Col xs={12}>
                        <label htmlFor="featureIdea1" className="d-block">
                          Can we call you about your feature idea?*
                        </label>
                        <label htmlFor="featureIdea1" className="switch">
                          <Field name="featureIdea" type="checkbox" />
                          <span
                            className="slider"
                            onClick={() => {
                              setFieldValue("featureIdea", !values.featureIdea);
                            }}
                          >
                            <span className={`yes ${values.featureIdea && "active"}`}>Yes</span>
                            <span className={`no ${!values.featureIdea && "active"}`}>No</span>
                          </span>
                        </label>
                      </Col>
                    </Row>
                  </div>

                  <div className="text-center">
                    <CustomButton variant="purple" className="mt-5" type="submit" gradient disabled={meta.isLoading}>
                      {meta.isLoading ? (
                        <span className="text-nowrap">
                          Sending... <SubmitLoader />
                        </span>
                      ) : (
                        <>Send It</>
                      )}
                    </CustomButton>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </section>
      ) : null}

      <Footer />
      <FooterBottom />
      <LoginModal isOpen={isModalLogin} onClosed={() => setIsModalLogin(false)} modal={setIsModalLogin} />
      <SuccessModal
        isOpen={success}
        onClosed={() => setSuccess(false)}
        title="Your vote on the feature has been successfully submitted. Thank you for participating and sharing your opinion with us."
        description="Vote Submitted Successfully!"
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.my_account.user_info,
  featureList: state.feature.feature_list,
  upcoming: state.cms.upcoming,
  meta: state.meta,
});

export default connect(mapStateToProps, {
  voteOnFeatureAction,
  getPublicFeatureListAction,
  addVoteAction,
  getUpcomingDetailsAction,
})(UpcomingFeatured);
